export default function PHP_define() {
  return (
    <div>
      <h1>PHP_define</h1>
    </div>
  );
}
